"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectYearSimple = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var moment_1 = __importDefault(require("moment"));
var SelectYearSimple = function (_a) {
    var value = _a.value, _b = _a.validRange, _c = _b === void 0 ? [
        moment_1.default().subtract(20, "year").year(),
        moment_1.default().endOf("year").year(),
    ] : _b, start = _c[0], end = _c[1], props = __rest(_a, ["value", "validRange"]);
    var yearsOptions = Array.from({ length: Math.abs(start - end) }, function (_, i) { return ({
        label: end - i,
        value: end - i,
    }); });
    return react_1.default.createElement(antd_1.Select, __assign({}, props, { options: yearsOptions, value: value }));
};
exports.SelectYearSimple = SelectYearSimple;
